<mat-form-field class="vehicle-number" appearance="outline">
  <mat-label>Search Vehicle</mat-label>
  <input
    matInput
    id-automation="searchVehicle"
    aria-label="vehicle"
    (ngModelChange)="vehcileMMV($event)"
    #autoCompleteInput
    [matAutocomplete]="autoVehicle"
    formControlName="vehicle"
    
  />
  <mat-autocomplete
    #autoVehicle="matAutocomplete"
    [displayWith]="displayVehicle.bind(this)"
    (opened)="onOpened()"
    (closed)="onClosed()"
    ><ng-container *ngIf="vehicleSearchDataLength > 2">
      <mat-option
        *ngIf="mmvDataNotAvailable === 'No result found'"
        [value]="'No result found'"
      >
        {{ mmvDataNotAvailable }}
      </mat-option>
    </ng-container>

    <span *ngIf="mmvDataNotAvailable !== 'No result found'">
      <mat-option
        *ngFor="let mmvData of filteredMMV | async"
        [value]="mmvData"
        [matTooltip]="
          (
            mmvData.rb_make_name +
            ' | ' +
            mmvData.rb_model_name +
            ' | ' +
            mmvData.rb_variant_name
          ).length > 32
            ? (mmvData.rb_make_name +
                ' | ' +
                mmvData.rb_model_name +
                ' | ' +
                mmvData.rb_variant_name)!
            : ''
        "
        matTooltipPosition="right"
      >
        <span
          >{{ mmvData.rb_make_name }} | {{ mmvData.rb_model_name }} |
          {{ mmvData.rb_variant_name }}</span
        >
      </mat-option>
    </span>
  </mat-autocomplete>
  <mat-error *ngIf="form.controls['vehicle']?.hasError('required')">
    This is a required field.
  </mat-error>
</mat-form-field>
<div class="d-flex justify-content-start" *ngIf="showSelectedFuelandCapacity">
  <span class="fuel-capacitor"
    >{{ vehicleSelectedData?.fuel }} &#8226;
    {{ vehicleSelectedData?.cubic_capacity }}cc</span
  >
</div>
